<section class="layout">
    <div class="heading">
        <h3 class="heading">Factory</h3>
    </div>
    <main class="content">
        <section class="list">
            <div class="data" *ngFor="let item of CRM;">
                <div class="d-flex">
                    <img [src]="[item.icon]">
                    <h4 class="menu-heading">{{item.heading}}</h4>
                </div>
                <ul *ngFor="let sub_head of item.sub_heading" class="page-content">
                    <li>
                        <!-- <i class="fas fa-star filled"></i> -->
                        <a [routerLink]="sub_head.router_link" class="custom-link">{{sub_head.label}}</a>

                    </li>
                </ul>
            </div>
        </section>
    </main>
</section>
